export default "__VITE_ASSET__74ae8f37__"